import { Typography, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import HeaderMain from "../../components/common/HeaderMain/HeaderMain";
import Promo from "../../components/single/Promo/Promo";
import HowItWorks from "../../components/single/HowItWorks/HowItWorks";
import NotableMoments from "../../components/single/NotableMoments/NotableMoments";
import TopSelling from "../../components/single/TopSelling/TopSelling";
import Resources from "../../components/single/Resources/Resources";
import PopularCreators from "../../components/single/PopularCreators/PopularCreators";
import ValueProposition from "../ValueProposition/ValueProposition";
import WhoItIsFor from "../WhoItIsFor/WhoItIsFor";
import Footer from "../../components/single/Footer/Footer";
import styles from "./Landing.module.css";

const Landing = () => {

  const handleSearch = (value) => {
    console.log("Search Input:", value);
  };

  return (
    <Box className={styles.landing}>
      <HeaderMain />
      <Promo handleSearch={handleSearch}/>
      <HowItWorks />
      <WhoItIsFor />
      <ValueProposition />
      {/* <NotableMoments heading={"Selected Notable Moments"}/> */}
      {/* <TopSelling /> */}
      <Resources />
      {/* <PopularCreators /> */}
      <Footer />
    </Box>
  );
};

export default Landing;
